import { Badge } from "@/components/ui";
import type { DomainStatus } from "@/lib/types";

const DOMAIN: Record<DomainStatus, [string, "success" | "warning" | "danger" | "neutral"]> = {
  pending_verification: ["Pending DNS", "warning"],
  active: ["Active", "success"],
  failed: ["Failed", "danger"],
  unknown: ["Unknown", "neutral"],
};

export function DomainStatusBadge({ status }: { status: DomainStatus }) {
  const [label, tone] = DOMAIN[status];
  return <Badge tone={tone}>{label}</Badge>;
}
